import '../../App.css';
import Navbar from '../../components/Navbar';
// import TeamBlock from '../../components/TeamBlocks';
// import { TeamBlockLarge } from '../../components/TeamBlocks';
import TeamPhotoCarousel from '../../components/TeamPhotoCarousel';
import TeamDemo from '../../components/TeamMemberPopover';
import PageHelmet from '../../components/PageHelmet';


// const leadership = [
//   {
//     img: '/img/portraits/ellenMichael.jpeg',
//     firstName: 'Ellen',
//     lastName: 'Michael',
//     linkedin: 'https://www.linkedin.com/in/ellenmariemichael/',
//     shortDescription: `As President of SnapRISK, Ellen Marie Michael leads with over 30 years of experience in HPR account management, 
//                   sales, and executive leadership.`,
//     longDescription: `As President of SnapRISK, Ellen Marie Michael leads with over 30 years of experience in HPR account management, sales, and executive leadership. 
//                   A former risk manager and seasoned industry executive, Ellen understands the challenges risk professionals face and turns that insight into practical, strategic 
//                   guidance for clients and teams alike. Known for her passion for solving problems and elevating client service, Ellen combines deep technical knowledge with a 
//                   results-driven mindset. Her leadership reflects the core of SnapRISK’s mission—to transform the complexity of property risk engineering into opportunity through 
//                   technology, expertise, and partnership. Ellen’s energy, authenticity, and commitment to excellence inspire those around her, driving both client success and team 
//                   growth.`,
//     title: 'President',
//     location: 'Phoenix, AZ'
//   }, 
//   {
//     img: '/img/portraits/gregLindsley.jpg',
//     firstName: 'Greg',
//     lastName: 'Lindsley',
//     linkedin: 'https://www.linkedin.com/in/greg-lindsley-5a12785/',
//     shortDescription: `Gregory Lindsley is a Partner at SnapRISK, overseeing company growth and services provided to our clients.`,
//     longDescription: `Gregory Lindsley is a Partner at SnapRISK, overseeing company growth and services provided to our clients. The procurement of 
//                   new client relationships is an important part of our growth, while acting as a point for comprehensive information regarding services provided 
//                   not only by SnapRISK but other partners as well as ours. Prior to joining SnapRISK, Mr. Lindsley was responsible for property loss control services 
//                   at both Global Risk Consultants and Aon Risk Services of Minnesota. Most recently he served as EVP at First Onsite Restoration where he learned 
//                   invaluable experiences with property mitigation/restoration services and processes in natural disaster area wide events.`,
//     title: 'Partner',
//     location: 'Phoenix, AZ'
//   }, 
// ]

// const sales = [
//   {
//     img: '/img/portraits/jerry_new.png',
//     firstName: 'Jerry',
//     lastName: 'Basta',
//     linkedin: 'https://www.linkedin.com/in/jerry-basta-92729a7/',
//     shortDescription: `Jerry Basta is an Account Manager and business development professional for SnapRISK.`,
//     longDescription: `Jerry Basta is an Account Manager and business development professional for SnapRISK. In his current role he leads the international sales, 
//                   marketing, and account management team, as well as managing supplier and partnership relationships. As Account Manager he assumes overall 
//                   responsibility for customer satisfaction, service performance, delivery, and quality. He is also responsible for developing new business for
//                   SnapRISK and new applications for the SnapRISK® technology platform.
//                   Prior to joining SnapRISK, Mr. Basta held leadership roles at Global Risk Consultants, First Onsite Restoration and Willis (now Willis Towers Watson). 
//                   His responsibilities included managing a global sales team, global account management and project management of multimillion dollar property claims. 
//                   He also acted as project manager for research projects in fire protection technology, including large scale fire testing for the aerosol and consumer products industry.`,
//     title: 'Executive Vice President',
//     location: 'Ann Arbor, MI'
//   }, 
//   {
//     img: '/img/portraits/paul_new.png',
//     firstName: 'Paul',
//     lastName: 'Fix',
//     linkedin: 'https://www.linkedin.com/in/paul-fix-177bb460/',
//     shortDescription: `Paul Fix is an Executive Vice President with SnapRISK and has extensive experience as a sales and account management executive.`,
//     longDescription: `Paul Fix is an Executive Vice President with SnapRISK and has extensive experience as a sales and account management executive. 
//                   He is well-connected throughout the global risk management and insurance community. His strengths include communication, collaboration, 
//                   critical thinking, strategic vision and building relationships that last a lifetime. In his current role he will continue to expand the 
//                   SnapRISK brand experience and delivery of innovative risk control services. Prior to joining SnapRISK, Mr. Fix held a variety of leadership 
//                   roles in insurance (FM & IRI), brokerage (Aon), property risk control (Global Risk Consultants), restoration (First Onsite) and client servicing 
//                   (all of the above). At GRC, he led the global sales team and was responsible for the overall growth, retention and development of risk control 
//                   opportunities for his clients. Each of these experiences will be invaluable for him in his role at SnapRISK as we continue to grow and exceed expectations.`,
//     title: 'Executive Vice President',
//     location: 'Minneapolis, MN'
//   }, 
//   {
//     img: '/img/portraits/jeff_new.png',
//     firstName: 'Jeff',
//     lastName: 'Nall',
//     linkedin: 'https://www.linkedin.com/in/jeff-nall-p-e-a4847313/',
//     shortDescription: 'Jeff Nall is responsible for managing the core services delivered to individual clients and oversight of all activity.',
//     longDescription: `Jeff Nall is responsible for managing the core services
//                   delivered to individual clients and oversight of all activity.
//                   As an experienced leader of property risk control consulting services and a registered
//                   professional engineer, Jeff is also responsible for marketing the services of SnapRISK® for client consulting
//                   relationships. His areas of expertise include corporate program development, property insurance submittals,
//                   complex risk consulting, quantitative risk assessment, and problem solving. In working with a major
//                   beverage client, he gained extensive experience in innovative protection methods for flammable liquid
//                   processing and storage, he also managed the publication of corporate standards.`,
//     title: 'Executive Vice President',
//     location: 'Atlanta, GA'
//   }, 
//   {
//     img: '/img/portraits/marco.png',
//     firstName: 'Marco',
//     lastName: 'Sobejano',
//     linkedin: 'https://www.linkedin.com/in/marcosobejano/',
//     shortDescription: `Marco Sobejano is the Managing Director for EMEA at SnapRISK, leading strategic growth and client engagement across Europe, 
//                     the Middle East, and Africa.`,
//     longDescription: `Marco Sobejano is the Managing Director for EMEA at SnapRISK, leading strategic growth and client engagement across Europe, 
//                     the Middle East, and Africa. With a strong background in risk engineering and global insurance program management, Marco works 
//                     closely with clients, brokers, and partners to deliver tailored, unbundled solutions that support long-term risk improvement. 
//                     He plays a key role in expanding SnapRISK’s footprint in the region and ensuring that our services align with the evolving needs 
//                     of both multinational and regional clients.`,
//     title: 'Managing Director EMEA',
//     location: 'Netherlands'
//   }, 
// ]

// const operations = [
//   {
//     img: '/img/portraits/kevinBeach.jpg',
//     firstName: 'Kevin',
//     lastName: 'Beach',
//     linkedin: 'https://www.linkedin.com/in/kevin-beach-a6a4a9aa/',
//     shortDescription: `Kevin attended the University of Illinois at Urbana-Champaign where he studied economics and computer
//                   science, and has experience working in both the financial and insurance industries.`,
//     longDescription: `Kevin attended the University of Illinois at Urbana-Champaign where he studied economics and computer
//                   science, and has experience working in both the financial and insurance industries. Since joining the
//                   team, Kevin has been continuously finding ways to integrate new technologies into SnapRISK® in order
//                   to make data collection and data analysis more seamless and efficient. His main focuses include data
//                   analytics, web development, and product innovation.`,
//     title: 'Lead Developer',
//     location: 'Phoenix, AZ'
//   }, 
//   {
//     img: '/img/portraits/matthewMaday.jpg',
//     firstName: 'Matthew',
//     lastName: 'Maday',
//     linkedin: 'https://www.linkedin.com/in/matthew-maday-981a46153/',
//     shortDescription: `Matthew holds a bachelor’s degree from Oklahoma State University in fire protection and safety
//                   engineering technology.`,
//     longDescription: `Matthew holds a bachelor’s degree from Oklahoma State University in fire protection and safety
//                   engineering technology. He began his career at FM Global as a field engineer and then as a licensed
//                   adjuster. Since joining the team, Matthew has applied his practical experience and knowledge to help
//                   innovate the way our clients approach property risk management. Matthew is focused on ensuring the
//                   SnapRISK team efficiently and effectively meets all of our clients risk management needs.`,
//     title: 'Director of Operations',
//     location: 'Chicago, IL'
//   }, 
//   {
//     img: '/img/portraits/annieTrapp.jpg',
//     firstName: 'Annie',
//     lastName: 'Trapp',
//     linkedin: 'https://www.linkedin.com/in/annie-trapp/',
//     shortDescription: 'Annie joined SnapRISK in 2019, working in client support and data analysis.',
//     longDescription: `Annie joined SnapRISK in 2019, working in client support and data analysis. After receiving her
//                     bachelor’s degree from Lee University in 2014, she worked in multiple industries throughout the
//                     Cincinnati area with a focus in account management and client relations. At SnapRISK, Annie enjoys
//                     working with a diverse client base, whether local or international. She is passionate about making
//                     SnapRISK meet a client's needs to be helpful and effective.`,
//     title: 'Client Success Manager',
//     location: 'Cincinnati, OH'
//   },
//   {
//     img: '/img/portraits/chrisPhillips.jpg',
//     firstName: 'Chris',
//     lastName: 'Phillips',
//     linkedin: 'https://www.linkedin.com/in/christopher-l-phillips-2b2a615b/',
//     shortDescription: `Christopher Lon Phillips is Director of Engineering at SnapRISK, where he leads risk assessment, 
//     mitigation, and client education across a wide range of industries.`,
//     longDescription: `Christopher Lon Phillips is Director of Engineering at SnapRISK, where he leads risk assessment, 
//     mitigation, and client education across a wide range of industries. He brings extensive experience in fire and equipment 
//     hazards, supporting clients with plan reviews, asset management strategies, and property loss prevention. Prior to 
//     joining SnapRISK, Mr. Phillips held roles with several global engineering and property insurance firms, where he 
//     managed accounts, conducted risk assessments, and led project follow-ups and loss investigations. Most recently, 
//     he served as Service Director for an Asset Management and Reliability solution developed during COVID-related 
//     supply chain disruptions, helping organizations optimize asset performance and reduce operating costs. `,
//     title: 'Director of Engineering',
//     location: 'Seattle, WA'
//   },
//   {
//     img: '/img/portraits/terry_new.png',
//     firstName: 'Terry',
//     lastName: 'Chavez',
//     linkedin: 'https://www.linkedin.com/in/terry-c-b72645319/',
//     shortDescription: `Terence (Terry) Chavez is Senior Infrared Thermographer at SnapRISK, bringing over 20 years of experience in electrical safety and thermography.`,
//     longDescription: `Terence (Terry) Chavez is Senior Infrared Thermographer at SnapRISK, bringing over 20 years of experience in electrical safety and thermography.
//      He specializes in infrared surveys and inspections across industrial, commercial, and manufacturing environments, with deep expertise in electrical 
//      power distribution and HVAC systems. A Certified General Electrician and ETR (Electro-Thermal Radiation) Specialist, Terry has supported high-stakes projects 
//      globally, consistently prioritizing safety and efficiency. Prior to joining SnapRISK, Terry owned Omen Electrical Safety Consultants LLC, delivering 
//      consulting and training services focused on electrical safety. He has also held senior roles at TÜV SÜD Global Risk Consultants and ABM Power LLC, 
//      strengthening his experience in safety consulting and code compliance. Most recently, he has been recognized for his expertise in forensic analysis
//       of PV power generation and solar array structures, while also serving as an FAA Certified Part 107 Drone Pilot, enhancing aerial inspection capabilities.
//  `,
//     title: 'Senior IR Thermographer',
//     // location: 'Virginia Beach, Virginia'
//   }
// ]

const TEAM_MEMBERS_LEADERSHIP = [
  {
    id: 1,
    name: 'Ellen Michael',
    title: 'President',
    location: 'United States ',
    category: 'Executive Leadership',
    bio: `As President of SnapRISK, Ellen Marie Michael brings more than 30 years of experience in HPR account management, sales, and executive leadership. 
    A former risk manager and seasoned industry executive, Ellen understands firsthand the challenges risk professionals face and brings that perspective to 
    solving complex problems, strengthening client relationships, and guiding strategic decisions. Known for her commitment to exceptional client service, 
    Ellen combines deep industry knowledge with a practical, results-oriented approach. Her leadership embodies SnapRISK’s mission to transform the complexity 
    of property risk engineering into opportunity through technology, expertise, and partnership. With an energetic and authentic leadership style, Ellen is 
    committed to building strong teams, creating lasting client relationships, and driving SnapRISK’s continued growth.`,
    photo: '/img/portraits/ellenMichael.jpeg',
    linkedin: 'https://www.linkedin.com/in/ellenmariemichael/'
  },
  {
    id: 2,
    name: 'Greg Lindsley',
    title: 'Partner',
    location: 'Phoenix, AZ',
    category: 'Executive Leadership',
    bio: `Gregory Lindsley is a Partner at SnapRISK, overseeing company growth and services provided to our clients. The procurement of 
                  new client relationships is an important part of our growth, while acting as a point for comprehensive information regarding services provided 
                  not only by SnapRISK but other partners as well as ours. Prior to joining SnapRISK, Mr. Lindsley was responsible for property loss control services 
                  at both Global Risk Consultants and Aon Risk Services of Minnesota. Most recently he served as EVP at First Onsite Restoration where he learned 
                  invaluable experiences with property mitigation/restoration services and processes in natural disaster area wide events.`,
    photo: '/img/portraits/gregLindsley.jpg',
    linkedin: 'https://www.linkedin.com/in/greg-lindsley-5a12785/'
  },
  {
    id: 4,
    name: 'Paul Fix',
    title: 'Executive Vice President, Operations & Growth',
    location: 'Minneapolis, MN',
    category: 'Executive Leadership',
    bio: `Paul Fix is an Executive Vice President with SnapRISK and has extensive experience as a sales and account management executive. 
                  He is well-connected throughout the global risk management and insurance community. His strengths include communication, collaboration, 
                  critical thinking, strategic vision and building relationships that last a lifetime. In his current role he will continue to expand the 
                  SnapRISK brand experience and delivery of innovative risk control services. Prior to joining SnapRISK, Mr. Fix held a variety of leadership 
                  roles in insurance (FM & IRI), brokerage (Aon), property risk control (Global Risk Consultants), restoration (First Onsite) and client servicing 
                  (all of the above). At GRC, he led the global sales team and was responsible for the overall growth, retention and development of risk control 
                  opportunities for his clients. Each of these experiences will be invaluable for him in his role at SnapRISK as we continue to grow and exceed expectations.`,
    photo: '/img/portraits/paul_new.png',
    linkedin: 'https://www.linkedin.com/in/paul-fix-177bb460/'
  }
]

const TEAM_MEMBERS = [
  {
    id: 3,
    name: 'Jerry Basta',
    title: 'Consultant',
    location: 'Ann Arbor, MI',
    category: 'Sales',
    bio: `Jerry Basta is an Account Manager and business development professional for SnapRISK. In his current role he leads the international sales, 
                  marketing, and account management team, as well as managing supplier and partnership relationships. As Account Manager he assumes overall 
                  responsibility for customer satisfaction, service performance, delivery, and quality. He is also responsible for developing new business for
                  SnapRISK and new applications for the SnapRISK® technology platform.
                  Prior to joining SnapRISK, Mr. Basta held leadership roles at Global Risk Consultants, First Onsite Restoration and Willis (now Willis Towers Watson). 
                  His responsibilities included managing a global sales team, global account management and project management of multimillion dollar property claims. 
                  He also acted as project manager for research projects in fire protection technology, including large scale fire testing for the aerosol and consumer products industry.`,
    photo: '/img/portraits/jerry_new.png',
    linkedin: 'https://www.linkedin.com/in/jerry-basta-92729a7/'
  },
  {
    id: 11,
    name: 'Terry Chavez',
    title: 'Infrared & Failure Diagnostics Specialist',
    location: 'United States',
    category: 'Operations',
    bio: `Terence (Terry) Chavez is Senior Infrared Thermographer at SnapRISK, bringing over 20 years of experience in electrical safety and thermography.
     He specializes in infrared surveys and inspections across industrial, commercial, and manufacturing environments, with deep expertise in electrical 
     power distribution and HVAC systems. A Certified General Electrician and ETR (Electro-Thermal Radiation) Specialist, Terry has supported high-stakes projects 
     globally, consistently prioritizing safety and efficiency. Prior to joining SnapRISK, Terry owned Omen Electrical Safety Consultants LLC, delivering 
     consulting and training services focused on electrical safety. He has also held senior roles at TÜV SÜD Global Risk Consultants and ABM Power LLC, 
     strengthening his experience in safety consulting and code compliance. Most recently, he has been recognized for his expertise in forensic analysis
      of PV power generation and solar array structures, while also serving as an FAA Certified Part 107 Drone Pilot, enhancing aerial inspection capabilities.
 `,
    photo: '/img/portraits/terryChavez.png',
    linkedin: 'https://www.linkedin.com/in/terry-c-b72645319/'
  },
  {
    id: 8,
    name: 'Matthew Maday',
    title: 'Director of Technology Solutions',
    location: 'Chicago, IL',
    category: 'Technology',
    bio: `Matthew holds a bachelor’s degree from Oklahoma State University in fire protection and safety
                  engineering technology. He began his career at FM Global as a field engineer and then as a licensed
                  adjuster. Since joining the team, Matthew has applied his practical experience and knowledge to help
                  innovate the way our clients approach property risk management. Matthew is focused on ensuring the
                  SnapRISK team efficiently and effectively meets all of our clients risk management needs.`,
    photo: '/img/portraits/matthewMaday.jpg',
    linkedin: 'https://www.linkedin.com/in/matthew-maday-981a46153/'
  },
  {
    id: 5,
    name: 'Jeff Nall',
    title: 'Executive Vice President',
    location: 'Atlanta, GA',
    category: 'Executive Sales',
    bio: `Jeff Nall is responsible for managing the core services
                  delivered to individual clients and oversight of all activity.
                  As an experienced leader of property risk control consulting services and a registered
                  professional engineer, Jeff is also responsible for marketing the services of SnapRISK® for client consulting
                  relationships. His areas of expertise include corporate program development, property insurance submittals,
                  complex risk consulting, quantitative risk assessment, and problem solving. In working with a major
                  beverage client, he gained extensive experience in innovative protection methods for flammable liquid
                  processing and storage, he also managed the publication of corporate standards.`,
    photo: '/img/portraits/jeff_new.png',
    linkedin: 'https://www.linkedin.com/in/jeff-nall-p-e-a4847313/',
  },
  {
    id: 10,
    name: 'Chris Phillips',
    title: 'Director of Engineering',
    location: 'Seattle, WA',
    category: 'Operations',
    bio: `Christopher Lon Phillips is Director of Engineering at SnapRISK, where he leads risk assessment, 
    mitigation, and client education across a wide range of industries. He brings extensive experience in fire and equipment 
    hazards, supporting clients with plan reviews, asset management strategies, and property loss prevention. Prior to 
    joining SnapRISK, Mr. Phillips held roles with several global engineering and property insurance firms, where he 
    managed accounts, conducted risk assessments, and led project follow-ups and loss investigations. Most recently, 
    he served as Service Director for an Asset Management and Reliability solution developed during COVID-related 
    supply chain disruptions, helping organizations optimize asset performance and reduce operating costs. `,
    photo: '/img/portraits/chrisPhillips.jpg',
    linkedin: 'https://www.linkedin.com/in/christopher-l-phillips-2b2a615b/'
  },
  {
    id: 7,
    name: 'Olivia Schanafelt',
    title: 'Business Support & Marketing Coordinator',
    location: 'Phoenix, AZ',
    category: 'Marketing',
    bio: `Olivia joined SnapRISK in 2025, supporting the company’s marketing and business operations. A graduate of the University of Arizona, she brings experience across a range of industries and a strong foundation in marketing, communications, and business support.
Since joining SnapRISK, Olivia has helped strengthen the company’s brand and expand its market presence. Her work includes supporting the launch of SnapRISK’s new website, developing branded and educational resources, creating social media content, and coordinating event marketing initiatives.
Olivia enjoys finding creative ways to communicate SnapRISK’s expertise, connect with its audiences, and build greater awareness of the company and its capabilities. Through these efforts, she helps strengthen the SnapRISK brand and supports the company’s continued growth.`,
    photo: '/img/portraits/oliviaSchanafelt.png',
    linkedin: 'https://www.linkedin.com/in/olivia-schanafelt/',
  },
  // {
  //   id: 6,
  //   name: 'Marco Sobejano',
  //   title: 'Managing Director EMEA',
  //   location: 'Netherlands',
  //   category: 'Executive Sales',
  //   bio: `Marco Sobejano is the Managing Director for EMEA at SnapRISK, leading strategic growth and client engagement across Europe, 
  //                   the Middle East, and Africa. With a strong background in risk engineering and global insurance program management, Marco works 
  //                   closely with clients, brokers, and partners to deliver tailored, unbundled solutions that support long-term risk improvement. 
  //                   He plays a key role in expanding SnapRISK’s footprint in the region and ensuring that our services align with the evolving needs 
  //                   of both multinational and regional clients.`,
  //   photo: '/img/portraits/marco.png',
  //   linkedin: 'https://www.linkedin.com/in/marcosobejano/'
  // },
  {
    id: 9,
    name: 'Annie Trapp',
    title: 'Client Success Manager',
    location: 'Cincinnati, OH',
    category: 'Operations',
    bio: `Annie joined SnapRISK in 2019, working in client support and data analysis. After receiving her
                    bachelor’s degree from Lee University in 2014, she worked in multiple industries throughout the
                    Cincinnati area with a focus in account management and client relations. At SnapRISK, Annie enjoys
                    working with a diverse client base, whether local or international. She is passionate about making
                    SnapRISK meet a client's needs to be helpful and effective.`,
    photo: '/img/portraits/annieTrapp.jpg',
    linkedin: 'https://www.linkedin.com/in/annie-trapp/'
  },
];


function OurTeam() {
  return (
    <div className="app">
      <PageHelmet
        title="SnapRISK | Team"
        description="Meet the SnapRISK leadership team and global network of property risk engineering professionals."
        path="/about/team"
      />
      <header className="hero" id="team">
        <Navbar />
      </header>

      <main className="px-4 pb-14 md:px-8 md:pb-18">
        <section className="mx-auto mt-10 max-w-5xl rounded-3xl border border-white/10 bg-secondary p-8 shadow-2xl shadow-primary/10 md:mt-14 md:p-12">
          <p className="text-center text-xs font-semibold uppercase tracking-[0.24em] text-primary/80">
            Meet Our Leadership Team
          </p>
          <h1 className="mt-3 text-center text-4xl font-bold leading-tight text-primary md:text-5xl">
            A Proven Global Team
          </h1>
          <p className="mx-auto mt-6 max-w-4xl text-center text-base leading-8 text-slate-100 md:text-lg">
            At SnapRISK, we have the most experienced GLOBAL team of skilled professionals in the
            industry.
          </p>
          <div className="mx-auto mt-8 max-w-4xl rounded-2xl border border-white/10 bg-slate-950/40 p-6 md:p-8">
            {/* <h2 className="text-center text-2xl font-semibold text-white md:text-3xl">A Proven Team</h2> */}
            <p className="mt-4 text-center text-sm leading-7 text-slate-300 md:text-base md:leading-8">
              We are proud of the experience that our team brings to the table, and we are committed
              to using it to help our clients succeed and grow in their respective industries. Our global
              team consists of HPR consultants with decades of experience under their belt.
            </p>
          </div>
        </section>

        <TeamDemo leadershipMembers={TEAM_MEMBERS_LEADERSHIP} teamMembers={TEAM_MEMBERS} />
      </main>

{/* OLD TEAM SECTIONS */}
      {/* <section>
        <h1 className="text-4xl font-bold text-center">Executive Leadership</h1>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8 px-24 py-12 lg:hidden">
        {leadership.map(person => (
          <TeamBlock key={person.firstName} teammate={person} />
        ))}
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8 px-24 py-12 hidden lg:grid">
        {leadership.map(person => (
          <TeamBlockLarge key={person.firstName} teammate={person} />
        ))}
        </div>
      </section>

      <section>
        <h1 className="text-4xl font-bold text-center">Executive Sales & Account Management</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 px-24 py-12 md:gap-8 lg:hidden">
          {sales.map((person) => (
            <div key={person.firstName} className="w-full">
              <TeamBlock teammate={person} />
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 px-24 py-12 md:gap-8 hidden lg:grid">
          {sales.map((person) => (
            <div key={person.firstName} className="w-full">
              <TeamBlockLarge teammate={person} />
            </div>
          ))}
        </div>
      </section>

      <section>
        <h1 className="text-4xl font-bold text-center">Operations & Engineering</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 px-24 py-12 md:gap-8 lg:hidden">
        {operations.map(person => (
          <div key= {person.firstName} className="w-full">
            <TeamBlock key={person.firstName} teammate={person} />
          </div>
        ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 px-24 py-12 md:gap-8 hidden lg:grid">
        {operations.map(person => (
          <div key= {person.firstName} className="w-full">
            <TeamBlockLarge key={person.firstName} teammate={person} />
          </div>
        ))}
        </div>
      </section> */}

      <TeamPhotoCarousel />
    </div>
  );
}

export default OurTeam;
